import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../../../styles/src/05-components/slideshow/style.scss';

document.addEventListener("DOMContentLoaded", function() {
    Swiper.use([Navigation, Pagination]);
    var menu = [];
    const menuItems = document.querySelector('.slideshow__menu');
    if (menuItems) {
        for (let i = 0; i < menuItems.children.length; i++) {
            menu.push(menuItems.children[i].textContent);
        }
    }

    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper('.slideshow .swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,

        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function(index, className) {
                return '<li class="' + className + '">' + (menu[index]) + '</li>';
            },
        },

        // Navigation arrows
        navigation: {
            nextEl: '.slideshow .swiper-button-next',
            prevEl: '.slideshow .swiper-button-prev',
        },
    });
});